import ProfissionaisDeApoioIndexPage from "@/Pages/ProfissionaisDeApoio/index.vue";
import NewEditProfissionalDeApoioPage from "@/Pages/ProfissionaisDeApoio/NewEditProfissionalDeApoioPage.vue";

export default [
  {
    path: "/profissionaisDeApoio/",
    name: "profissionaisDeApoio",
    component: ProfissionaisDeApoioIndexPage,
  },
  {
    path: "/profissionaisDeApoio/create",
    name: "profissionaisDeApoio.create",
    component: NewEditProfissionalDeApoioPage,
    props: { editing: false },
  },
  {
    path: "/profissionaisDeApoio/edit/:profissionalDeApoio_id",
    name: "profissionaisDeApoio.edit",
    component: NewEditProfissionalDeApoioPage,
    props: { editing: true },
  },
];
